import { render, staticRenderFns } from "./SearchArticle.vue?vue&type=template&id=70b2a3aa&scoped=true"
import script from "./SearchArticle.vue?vue&type=script&lang=js"
export * from "./SearchArticle.vue?vue&type=script&lang=js"
import style0 from "./SearchArticle.vue?vue&type=style&index=0&id=70b2a3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2a3aa",
  null
  
)

export default component.exports